import { useSlideInContext, useManageModal } from "ui";
import { useStudentContext } from "../../../context/studentContext";
import { StudentDataType, Subscription, ParentalConsentType, SubscriptionModel, SEND_SESSION_REQUEST_ACTION, SCREEN_VERSION, Student, convert_enum_to_string, GET_STUDENTS_PAGE, QueryOrigin, canAddStudentAndStaff } from "ft-shared-graphql";
import { useNavigate } from "react-router";
import { LaunchRequest, StudentTable, ParentalConsentRequest, GetTriageRequest } from "ft-shared-components";
import { format } from "date-fns"
import { PARENTAL_CONSENT, LAUNCH_FOR_OTHERS, LAUNCH_FOR_SELF } from "ft-shared-components";
import usePersonAuthStore, { decodedToken } from "../../store/personAuthStore"
import usePersonStore from "../../store/personStore";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
const DEFAULT_PAGE_SIZE = 100
const StudentTableComponent = ({ roles, subscriptions }: { roles: any[], subscriptions: SubscriptionModel[] }) => {
    const navigate = useNavigate();
    const { openModal, closeModal } = useManageModal()
    const queryOrigin = window.location.pathname.includes("dashboard") ? QueryOrigin.Dashboard : QueryOrigin.Manage
    const { changeStudent, studentData, updateStudent, bulkStudents, updateBulkStudents } = useStudentContext()

    const [getStudents, { refetch: refetch_students }] = useLazyQuery(GET_STUDENTS_PAGE, {
        notifyOnNetworkStatusChange: true,
        variables: {
            query: "",
            first: DEFAULT_PAGE_SIZE,
            origin: queryOrigin
        }
    })

    const { handleContent, toggleDrawer, disableClosingDrawer } = useSlideInContext()
    const accessToken = usePersonAuthStore(state => state.access_token)
    const personState = usePersonStore(state => state)
    const [results, setResults] = useState<{
        success: StudentDataType[],
        error: StudentDataType[]
    }>({
        success: [],
        error: []
    })
    const total = bulkStudents.allStudents.length;
    const finished = results.success.length + results.error.length;
    const isComplete = total > 0 && finished >= total;
    const hasErrors = results.error.length > 0;

    useEffect(() => {
        if (!isComplete) return;

        if (hasErrors) {
            updateBulkStudents([], [], results.error as Student[], results.success as Student[]);
            handlePartialSuccessMessage();
        } else {
            updateBulkStudents([], [], [], results.success as Student[]);
            handleSuccessMessage('bulk');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComplete]);
    const handleSelectedStudent = (student: StudentDataType) => {
        changeStudent(student)
        navigate(`/dashboard/student/${student?.id}/sessions`)
    }
    const handleStudentDetails = (student: StudentDataType) => {
        changeStudent(student)
        navigate(`/manage/children/details/${student?.id}`)
    }

    const handleSubmitLaunch = async (request: LaunchRequest) => {
        if (accessToken) {
            // Sleep for a simulated 10 seconds if intent is to send an email
            const { pid, lid } = decodedToken(accessToken);
            const resposne = await fetch(`${window.__env.API_URL}/api/session/send`, {
                method: "post",
                headers: {
                    Pid: request.launchPerson ?? pid,
                    Lid: personState.company.defaultLocation?.id ?? lid,
                    "Content-Type": "application/json",
                    authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    action: request.action,
                    type: request.screenTypeParsed,
                    language: request.languageParsed,
                    studentId: request.studentId,
                    email: request.email,
                    launchPersonId: personState.id,
                    enteredAt: format(new Date(), "yyyy-MM-dd'T'HH:mm:ssXXX")
                }),
            });
            if (resposne.status >= 400) {
                openModal({ type: "REMOTE_LAUNCH_FAILURE", cancelButtonLabel: "close" })
            }

            if (resposne.status === 202) {
                handleSuccessMessage('success');
                return;
            }

            if (resposne.status === 200) {
                const json = await resposne.json();
                if (request.action === "link") {
                    openModal({ type: "LINK_PREPARED", cancelButtonLabel: "close", messageProps: { sessionLink: json.redirectUrl } })
                } else {
                    window.location.replace(json.redirectUrl);
                    window.sessionStorage.clear();
                }
            }
        }
    };

    const handlePartialSuccessMessage = () => {
        toggleDrawer();
        disableClosingDrawer(false);
        openModal({ type: "REMOTE_LAUNCH_PARTIAL_SUCCESS", messageProps: { students: results.error }, eventType: 'DISABLE_BACKDROP', cancelButtonLabel: "Close", onCancel: () => clearResults() })
    }
    const clearResults = () => {
        setResults({ success: [], error: [] })
    }
    const handleSendParentalConsent = async ({ action, studentId, noteOrigin }: ParentalConsentRequest) => {

        if (accessToken) {
            let newWindow: Window | null = null;

            if (action === "local") {
                newWindow = window.open("", "_blank");
            }
            const { pid, lid } = decodedToken(accessToken ?? '');
            const response = await fetch(`${window.__env.API_URL}/api/parent/consent/send`, {
                method: "POST",
                headers: {
                    Pid: pid,
                    Lid: lid,
                    "Content-Type": "application/json",
                    authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    action: action,
                    personId: pid,
                    studentId: studentId,
                    companyId: personState.company.id,
                    NoteOrigin: convert_enum_to_string(origin)
                })
            })
            if (response.status >= 400) {
                openModal({ type: "PARENTAL_CONSENT_ERROR", cancelButtonLabel: "close" })
            }
            if (response.status === 200) {
                // const newWindow = window.open("", "_blank"); // MUST be sync
                const json = await response.json();
                if (newWindow) { //just guarding it
                    newWindow.location.href = json.redirectUrl;
                }


                handleSuccessMessage("signNow")
            }

            if (response.status === 202) {
                if (!window.location.pathname.includes("sessions")) {
                    refetch_students()
                } else {
                    // refetch_sessions()
                }
                updateStudent({
                    ...studentData,
                    lastConsentAction: {
                        ...studentData.lastConsentAction,
                        createdAt: new Date()
                    },
                    consentEmailSentTimes: studentData.consentEmailSentTimes + 1
                })
                handleSuccessMessage("notification");
                return;
            }
        }
        disableClosingDrawer(false);
        toggleDrawer();
    }
    const handleSuccessMessage = (source: string) => {
        toggleDrawer()
        disableClosingDrawer(false);
        if (source === "notification") {
            openModal({ type: "PARENTAL_CONSENT_SENT", eventType: "DISABLE_BACKDROP", cancelButtonLabel: "Close" })
        } else if (source === "signNow") {
            openModal({ type: "PARENTAL_CONSENT_LOCAL", eventType: "DISABLE_BACKDROP", cancelButtonLabel: "Close" })
        } else if (source === 'bulk') {
            openModal({ type: "REMOTE_LAUNCH_SUCCESS", eventType: 'DISABLE_BACKDROP', cancelButtonLabel: "Close", onCancel: () => clearResults() });
        } else {
            openModal({ type: "REMOTE_LAUNCH_SUCCESS", eventType: 'DISABLE_BACKDROP', cancelButtonLabel: "Close" })
        }
    }

    const handleLaunch = (student: any) => {
        if (student?.expired) {
            openModal({
                type: 'STUDENT_IS_EXPIRED',
                cancelButtonLabel: "Close"
            })
        }
        else {
            changeStudent(student);
            const studentConsentStatus = student.parentalConsentStatus?.toUpperCase() ?? null;
            if (personState.company.consentPolicy && (studentConsentStatus !== ParentalConsentType.Given && studentConsentStatus !== ParentalConsentType.Timelapsed)) {
                if (!studentConsentStatus) {
                    handleContent(PARENTAL_CONSENT, {
                        studentData: student as StudentDataType,
                        updateStudent: updateStudent,
                        companyId: personState.company.id!,
                        onSubmit: handleSendParentalConsent
                    })
                } else if (studentConsentStatus === ParentalConsentType.Pending) {
                    handleContent(PARENTAL_CONSENT, {
                        studentData: student as StudentDataType,
                        updateStudent: updateStudent,
                        companyId: personState.company.id!,
                        onSubmit: handleSendParentalConsent
                    })
                    openModal({ type: "PARENTAL_CONSENT_PENDING", cancelButtonLabel: "close" })
                } else {
                    openModal({ type: "PARENTAL_CONSENT_NOT_GIVEN", cancelButtonLabel: "close" })
                }
            }
            else if (roles.includes("MEDICAL STANDARD") || roles.includes("MEDICAL ADMIN") || roles.includes("MEDICAL SUPER") || roles.includes("EDUCATION SUPER")) {
                handleContent(LAUNCH_FOR_OTHERS, {
                    studentData: student,
                    subscriptions: subscriptions as Subscription[],
                    updateStudent: updateStudent,
                    onSubmit: handleSubmitLaunch
                })
                // TODO: ADD A NEW FUNCTION TO ALLOW THEM TO LAUNCH ON BEHALF OF OTHERS
            } else {
                handleContent(LAUNCH_FOR_SELF, {
                    studentData: student,
                    subscriptions: subscriptions as Subscription[],
                    updateStudent: updateStudent,
                    onSubmit: handleSubmitLaunch
                });
            }
        }
    }

    const handleBulkLaunch = (action: SEND_SESSION_REQUEST_ACTION, screenType: SCREEN_VERSION) => {
        if (accessToken) {
            bulkStudents.allStudents.forEach(async (student) => {
                if (action === "notification") {
                    openModal({ type: "REMOTE_LAUNCH_INITIALIZED", eventType: 'DISABLE_BACKDROP_AND_CTA', cancelButtonLabel: "Close" });
                    // await sleep(1000 * 10)
                }
                const { pid, lid } = decodedToken(accessToken);
                const resposne = await fetch(`${window.__env.API_URL}/api/session/send`, {
                    method: "post",
                    headers: {
                        Pid: pid,
                        Lid: personState.company.defaultLocation?.id ?? lid,
                        "Content-Type": "application/json",
                        authorization: `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify({
                        action: action,
                        type: screenType,
                        studentId: student.id,
                        language: "ENGLISH",
                        email: student.email,
                        launchPersonId: personState.id,
                        enteredAt: format(new Date(), "yyyy-MM-dd'T'HH:mm:ssXXX")
                    }),
                });

                if (resposne.status === 202) {
                    setResults(prevResults => ({
                        ...prevResults,
                        success: [...prevResults.success, student]
                    }))
                    return;
                } else {
                    setResults(prevResults => ({
                        ...prevResults,
                        error: [...prevResults.error, student]
                    }))
                }
            })
        }
    }
    const handleGetTriage = async (values: GetTriageRequest) => {
        const { sessionDate, searchParam, customfieldId, category } = values

        if (accessToken) {
            openModal({ type: "TRIAGE_GENERATION_INITIALIZED", eventType: "DISABLE_BACKDROP", cancelButtonLabel: "Close" })
            const { pid, lid } = decodedToken(accessToken);
            const response = await fetch(`${window.__env.API_URL}/api/triage/create-search`, {
                method: "POST",
                headers: {
                    Pid: pid,
                    Lid: personState.company.defaultLocation!.id ?? lid,
                    "Content-Type": "application/json",
                    authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    sessionDate: sessionDate ?? null,
                    searchParam: searchParam,
                    customfieldId: customfieldId,
                    category: category
                }),

            })
            if (response.status === 404) {
                openModal({ type: "TRIAGE_NO_SESSIONS_FOUND" })
            } else if (response.status >= 500) {
                openModal({ type: "GENERAL_ERROR" });
            }
            if (response.ok) {
                const fileId = await response.json()
                closeModal()
                const link = document.createElement('a');
                link.href = `${window.__env.API_URL}/api/file/download/client/triage-reports/${fileId.fileId}`
                link.target = "_blank"
                // TODO: MAKE A LOADING PAGE AND STATE FOR THIS
                // Prevent potential memory leak and cleanup ObjectURL
                // resources that are no longer in use
                const linkHandler = () => {
                    setTimeout(() => {
                        link.removeEventListener('click', linkHandler);
                        document.body.removeChild(link);
                    }, 300);
                }
                link.addEventListener('click', linkHandler);
                document.body.appendChild(link);
                link.click()
                toggleDrawer()
            }
        }
    }

    return (
        <StudentTable
            title="Children"
            showNew={!canAddStudentAndStaff(roles)}
            onSelectedStudent={(student, action) => {
                switch (action) {
                    case "LAUNCH":
                        handleLaunch(student)
                        break;
                    case "REPORTS":
                        handleSelectedStudent(student)
                        break;
                    case "DETAILS":
                        handleStudentDetails(student)
                        break;
                    default:
                        throw Error(`Although the student ${student.id} is selected, action ${action} is not implemented`);
                }
            }}
            onBulkLaunch={handleBulkLaunch}
            bulkStudents={bulkStudents}
            updateBulkStudents={updateBulkStudents}
            person={personState}
            submitTriage={handleGetTriage}
            roles={roles}
        />
    )
}
export default StudentTableComponent